import type { ActionLogsResponse } from 'backend/types'
import { apiFetch } from '..'

/**
 * オポチュニティアクションログ一覧取得API
 *
 * @param opportunityId - オポチュニティID
 * @param params - クエリパラメータ
 * @returns アクションログ一覧レスポンス
 * @throws ApiError
 */
export async function getOpportunityActionLogs(
  opportunityId: number,
  params?: {
    offset?: number
    limit?: number
  },
): Promise<ActionLogsResponse> {
  const queryParams = new URLSearchParams()
  if (params?.offset !== undefined) {
    queryParams.append('offset', params.offset.toString())
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }

  const queryString = queryParams.toString()
  const url = `/api/opportunity/${opportunityId}/action-logs${queryString ? `?${queryString}` : ''}`

  return apiFetch<ActionLogsResponse>(url, { method: 'GET' })
}
